<template>
	<ul class="kids-linkage--area-info">
		<li
			v-for="(item, index) in data"
			:key="'area_list' + index"
			class="kids-linkage--item">
			<input
				hidden
				type="radio"
				:id="'area_list' + index"
				:value="item.label"
				v-model="area">
			<label
				@click="emitValue(item.label)"
				:for="'area_list' + index"
				class="kids-linkage--option">{{item.label}}</label>
		</li>
	</ul>

</template>

<script>
    export default {
			name: "area_list",
			props: {
				data:{
					type: Array,
					require: true,
					default: () => []
				},
				defaultVal: {
					type: String,
					require: false,
				},
				isSelectingDistrict: {
					type: Boolean,
					require: false,
				}
			},
			data() {
        	return {
						area: []
					}
			},
			watch: {
				defaultVal(newVal) {
					this.area= newVal;
				}
			},
			methods: {
				emitValue(val) {
					this.$emit('selected', val);
					setTimeout(
						() => {
							if (!this.isSelectingDistrict) {
								this.area = null;
							}
						}
					)
				}

			}
    }
</script>

<style lang="scss">
	@import "~@/assets/style/mixin.scss";
	@function  rem($px) { @return px2rem($px)}
	.kids-linkage{
		&--area-info{
			height: 100%;
			overflow-y: scroll;
			overflow-x: hidden;
		}
		&--option{
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;
			padding: rem(15) 0;
			font-size:rem(26);
			font-weight:400;
			color:rgba(51,51,51,1);
			line-height:rem(30);
		}
		input:checked + &--option{
			font-weight:600;
			color:rgba(239,76,79,1);
			&::after{
				display: inline-block;
				content: "";
				width: rem(16);
				height: rem(13);
				background: url("./image/icon_selected@2x.png") center center no-repeat / 100%;
			}
		}
	}
</style>
